















































































import Vue from "vue";
import Navigation from "../components/Navigation.vue";
import { mapState } from "vuex";

export default Vue.extend({
  components: {
    Navigation
  },
  data() {
    return {
      displayed: false,
      showNavigation: false
    };
  },
  computed: mapState(["currentState"]),
  watch: {
    currentState(newVal, oldVal) {
      this.$data.displayed = false;
      this.$data.showNavigation = false;
    }
  },
  methods: {
    toggleNavigationMenu() {
      this.$data.displayed = !this.$data.displayed;
      if (this.$data.displayed) {
        setTimeout(() => {
          this.$data.showNavigation = true;
        }, 600);
      } else {
        this.$data.showNavigation = false;
      }
    }
  }
});
